import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Blank from "../../components/DefaultStyles/Blank";
import ChildPageNav from "../../components/DefaultStyles/ChildPageNav";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { useApi } from "../../hooks/useApi";
import UserDetailDefaultInfo from "../../components/pages/Users/UserDetail/UserDetailDefaultInfo";
import UserDetailHeader from "../../components/pages/Users/UserDetail/UserDetailHeader";
import UserDetailPayInfo from "../../components/pages/Users/UserDetail/UserDetailPayInfo";
import UserDetailPartyInfo from "../../components/pages/Users/UserDetail/UserDetailPartyInfo";
import UserDetailComment from "../../components/pages/Users/UserDetail/UserDetailComment";
import Loader from "../../components/DefaultStyles/Loader";
import { useRecoilValue } from "recoil";
import { authType } from "../Login";
import { toast } from "react-toastify";
import UserDetailMatchingInfo from "../../components/pages/Users/UserDetail/UserDetailMatchingInfo";
import UserDetailPayHistory from "../../components/pages/Users/UserDetail/UserDetailPayHistory";
import UserDetailUplusInfo from "../../components/pages/Users/UserDetail/UserDetailUplusInfo";
import UserDetailAlimtalk from "../../components/pages/Users/UserDetail/UserDetailAlimtalk";
import UserDetailLMS from "../../components/pages/Users/UserDetail/UserDetailLMS";

export default function UserDetail() {
  const { userId } = useParams();
  const auth = useRecoilValue(authType);
  const [showPayHistory, setShowPayHistory] = React.useState(false);

  const { response, fetchData, loading, error } = useApi({
    method: "get",
    url: auth?.userInfo ? `user/${userId}` : undefined,
  });

  useEffect(() => {
    if (error) {
      toast.error("유저 정보를 찾을 수 없습니다.");
    }
  }, [error]);

  return (
    <>
      <SpaceBetween>
        <>
          <PageTitle title="회원 상세" route={"/users/info"} />

          <ChildPageNav parentRoute="/users/info" />
        </>
      </SpaceBetween>

      <UserDetailHeader
        userId={userId}
        data={response?.data}
        fetchData={fetchData}
        loading={loading}
      />

      <Blank blankHeight={20} />

      <Row>
        {/* 기본 정보 */}
        <Column>
          <UserDetailDefaultInfo
            data={response?.data}
            status={response?.status}
            fetchData={fetchData}
          />
        </Column>

        {/* 정산 정보 */}
        <Column>
          <UserDetailPayInfo data={response?.data} fetchData={fetchData} />
        </Column>
      </Row>

      <Blank blankHeight={20} />

      {/* 파티 정보 */}
      <UserDetailPartyInfo userId={userId} />
      <Blank blankHeight={20} />

      {/* 유플러스 결합 정보 */}
      <UserDetailUplusInfo userId={userId} />

      {/* 매칭 정보 */}
      <UserDetailMatchingInfo userId={userId} />

      {/* 코멘트 */}
      <UserDetailComment userId={userId} />

      {/* 알림톡 */}
      <UserDetailAlimtalk userId={userId} />

      {/* LMS */}
      <UserDetailLMS userId={userId} />

      {/* 정산 내역 */}
      {!showPayHistory ? (
        <PayHistoryButtonWrapper>
          <PayHistoryButton onClick={() => setShowPayHistory(true)}>
            정산내역 보기
          </PayHistoryButton>
        </PayHistoryButtonWrapper>
      ) : (
        <UserDetailPayHistory userId={userId} />
      )}

      {loading && <Loader />}
    </>
  );
}

export const Row = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: calc(37%) calc(63% - 20px);
  grid-column-gap: 20px;
`;

export const Column = styled.div`
  min-height: 457px;
  &:first-child {
    width: 100%;
  }

  &:last-child {
    width: 100%;
  }
`;

const PayHistoryButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

const PayHistoryButton = styled.button`
  padding: 12px 24px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #357abd;
  }

  &:active {
    background-color: #2d6ba3;
  }
`;
